import styled, { css } from 'styled-components';

const Wrap = styled.div`
    display: flex;
    background: ${({ theme }) => theme.colors.ElementBackground};
    box-shadow: 0px 7px 15px rgba(0, 0, 0, 0.13),
        0px 0px 3px rgba(0, 0, 0, 0.05);
    border-radius: 8px;
    visibility: hidden;
    opacity: 0;
    transform: scale(0.9);
    transition: all 0.2s cubic-bezier(0.4, 0, 1, 1);
    ${({ shouldShowMenu }) => shouldShowMenu
        && css`
            visibility: visible;
            opacity: 1;
            transform: scale(1);
            transition: all 0.2s cubic-bezier(0, 0, 0.2, 1);
        `};
    ${({ theme }) => theme.superQuery.all.and.maxWidth.tabletMax.css`
        display: none;
    `}
`;
export default Wrap;
